// Store listings for the native BlackBelts mobile app. The backend mirror of
// these URLs lives in DownloadsController (user-agent smart redirect).
export const APP_STORES = {
  APPLE_APP_ID: '6780327556',
  APP_STORE_URL: 'https://apps.apple.com/br/app/blackbelts-jiu-jitsu/id6780327556',
  PLAY_STORE_URL: 'https://play.google.com/store/apps/details?id=app.blackbelts',
  // Single share-friendly URL (QR codes, bio links): the server redirects
  // phones straight to the right store and desktops to the home page.
  DOWNLOAD_URL: 'https://www.blackbelts.app/download',
} as const;
